import { config } from '@services/config';
import { CustomerSearchRequestQuery, CustomerSearchResponse } from '@lio/api-types';
import { customerQueryKey } from '@services/customer/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { omitBy, isNil } from 'lodash';

export const useCustomers = (params: CustomerSearchRequestQuery) => {
  const client = useClient();
  const queryParams = omitBy(
    {
      name: params.name ?? '',
      pageLimit: params.pageLimit ?? '10',
      pageOffset: params.pageOffset,
      sort: params.sort ?? 'name',
    },
    isNil,
  ) as Record<string, string>;
  const queryString = new URLSearchParams(queryParams);
  const result = useQuery<CustomerSearchResponse, Error>({
    queryKey: customerQueryKey.searchCustomers({ ...params }),
    queryFn: async () => {
      const response = await client.get(`customer?${queryString}`).json<CustomerSearchResponse>();
      return response;
    },
    ...config,
  });
  return { ...result, customers: result.data?.items || [] };
};
